// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomCard_root__1A3No","body":"CustomCard_body__2_mM3"};